/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';

function Button({
  type = 'button',
  label = 'Button',
  disabled = false,
  palette = 'primary',
  ...props
}) {
  const btnClass = classNames({
    'tv-button': true,
    'tv-button--disabled': disabled,
    'tv-button--primary': palette === 'primary',
    'tv-button--outline': palette === 'outline',
    'tv-button--secondary': palette === 'secondary',
    'tv-button--text': palette === 'text',
  });
  return (
    <button
      type={type || 'button'}
      {...props}
      className={`${btnClass} ${props.className}`}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

Button.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  palette: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Button;
